import { AxiosResponse } from "axios";
import { KeyValue } from "@/main/models/common";
import { Result } from "@/main/models/common/resultResponse";

export abstract class IStatusRegisterApi {
	abstract getDomain(showPending: boolean): Promise<AxiosResponse<Result<KeyValue[]>>>;
}
